import { render, staticRenderFns } from "./RouterCom.vue?vue&type=template&id=5fc48edc&scoped=true"
var script = {}
import style0 from "./RouterCom.vue?vue&type=style&index=0&id=5fc48edc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc48edc",
  null
  
)

export default component.exports